module.exports = [{"title":"Авто из Германии","link":"/avto/germaniya/"},{"title":"Авто из Польши","link":"/avto/polsha/"},{"title":"Авто из Литвы","link":"/avto/litva/"},{"title":"Авто из Латвии","link":"/avto/latviya/"},{"title":"Авто из США","link":"/avto/ssha/"}]


//////////////////
// WEBPACK FOOTER
// ./src/shared/data/json/topics.json
// module id = 2904
// module chunks = 33